import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Rider\GarageController::index
* @see app/Http/Controllers/Rider/GarageController.php:24
* @route '/profil/garaz'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/profil/garaz',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Rider\GarageController::index
* @see app/Http/Controllers/Rider/GarageController.php:24
* @route '/profil/garaz'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Rider\GarageController::index
* @see app/Http/Controllers/Rider/GarageController.php:24
* @route '/profil/garaz'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::index
* @see app/Http/Controllers/Rider/GarageController.php:24
* @route '/profil/garaz'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::index
* @see app/Http/Controllers/Rider/GarageController.php:24
* @route '/profil/garaz'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::index
* @see app/Http/Controllers/Rider/GarageController.php:24
* @route '/profil/garaz'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::index
* @see app/Http/Controllers/Rider/GarageController.php:24
* @route '/profil/garaz'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Rider\GarageController::create
* @see app/Http/Controllers/Rider/GarageController.php:39
* @route '/profil/garaz/nova'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/profil/garaz/nova',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Rider\GarageController::create
* @see app/Http/Controllers/Rider/GarageController.php:39
* @route '/profil/garaz/nova'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Rider\GarageController::create
* @see app/Http/Controllers/Rider/GarageController.php:39
* @route '/profil/garaz/nova'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::create
* @see app/Http/Controllers/Rider/GarageController.php:39
* @route '/profil/garaz/nova'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::create
* @see app/Http/Controllers/Rider/GarageController.php:39
* @route '/profil/garaz/nova'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::create
* @see app/Http/Controllers/Rider/GarageController.php:39
* @route '/profil/garaz/nova'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::create
* @see app/Http/Controllers/Rider/GarageController.php:39
* @route '/profil/garaz/nova'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Rider\GarageController::store
* @see app/Http/Controllers/Rider/GarageController.php:44
* @route '/profil/garaz'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/profil/garaz',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Rider\GarageController::store
* @see app/Http/Controllers/Rider/GarageController.php:44
* @route '/profil/garaz'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Rider\GarageController::store
* @see app/Http/Controllers/Rider/GarageController.php:44
* @route '/profil/garaz'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::store
* @see app/Http/Controllers/Rider/GarageController.php:44
* @route '/profil/garaz'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::store
* @see app/Http/Controllers/Rider/GarageController.php:44
* @route '/profil/garaz'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Rider\GarageController::edit
* @see app/Http/Controllers/Rider/GarageController.php:53
* @route '/profil/garaz/{vehicle}/upravit'
*/
export const edit = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/profil/garaz/{vehicle}/upravit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Rider\GarageController::edit
* @see app/Http/Controllers/Rider/GarageController.php:53
* @route '/profil/garaz/{vehicle}/upravit'
*/
edit.url = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { vehicle: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { vehicle: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            vehicle: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        vehicle: typeof args.vehicle === 'object'
        ? args.vehicle.id
        : args.vehicle,
    }

    return edit.definition.url
            .replace('{vehicle}', parsedArgs.vehicle.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Rider\GarageController::edit
* @see app/Http/Controllers/Rider/GarageController.php:53
* @route '/profil/garaz/{vehicle}/upravit'
*/
edit.get = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::edit
* @see app/Http/Controllers/Rider/GarageController.php:53
* @route '/profil/garaz/{vehicle}/upravit'
*/
edit.head = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::edit
* @see app/Http/Controllers/Rider/GarageController.php:53
* @route '/profil/garaz/{vehicle}/upravit'
*/
const editForm = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::edit
* @see app/Http/Controllers/Rider/GarageController.php:53
* @route '/profil/garaz/{vehicle}/upravit'
*/
editForm.get = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::edit
* @see app/Http/Controllers/Rider/GarageController.php:53
* @route '/profil/garaz/{vehicle}/upravit'
*/
editForm.head = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Rider\GarageController::update
* @see app/Http/Controllers/Rider/GarageController.php:78
* @route '/profil/garaz/{vehicle}'
*/
export const update = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/profil/garaz/{vehicle}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Rider\GarageController::update
* @see app/Http/Controllers/Rider/GarageController.php:78
* @route '/profil/garaz/{vehicle}'
*/
update.url = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { vehicle: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { vehicle: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            vehicle: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        vehicle: typeof args.vehicle === 'object'
        ? args.vehicle.id
        : args.vehicle,
    }

    return update.definition.url
            .replace('{vehicle}', parsedArgs.vehicle.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Rider\GarageController::update
* @see app/Http/Controllers/Rider/GarageController.php:78
* @route '/profil/garaz/{vehicle}'
*/
update.patch = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::update
* @see app/Http/Controllers/Rider/GarageController.php:78
* @route '/profil/garaz/{vehicle}'
*/
const updateForm = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::update
* @see app/Http/Controllers/Rider/GarageController.php:78
* @route '/profil/garaz/{vehicle}'
*/
updateForm.patch = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Rider\GarageController::destroy
* @see app/Http/Controllers/Rider/GarageController.php:88
* @route '/profil/garaz/{vehicle}'
*/
export const destroy = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/profil/garaz/{vehicle}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Rider\GarageController::destroy
* @see app/Http/Controllers/Rider/GarageController.php:88
* @route '/profil/garaz/{vehicle}'
*/
destroy.url = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { vehicle: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { vehicle: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            vehicle: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        vehicle: typeof args.vehicle === 'object'
        ? args.vehicle.id
        : args.vehicle,
    }

    return destroy.definition.url
            .replace('{vehicle}', parsedArgs.vehicle.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Rider\GarageController::destroy
* @see app/Http/Controllers/Rider/GarageController.php:88
* @route '/profil/garaz/{vehicle}'
*/
destroy.delete = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::destroy
* @see app/Http/Controllers/Rider/GarageController.php:88
* @route '/profil/garaz/{vehicle}'
*/
const destroyForm = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Rider\GarageController::destroy
* @see app/Http/Controllers/Rider/GarageController.php:88
* @route '/profil/garaz/{vehicle}'
*/
destroyForm.delete = (args: { vehicle: number | { id: number } } | [vehicle: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const garage = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default garage